import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import api from './config/axios-config'
import VueAxios from 'vue-axios'

import 'ant-design-vue/dist/antd.css'
import 'bootstrap/dist/css/bootstrap-grid.min.css'
import 'bootstrap/dist/css/bootstrap-utilities.min.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-icons/font/bootstrap-icons.css'

import { createPinia } from 'pinia'
import Antd from 'ant-design-vue'
import '@/theme/theme.css'

const app = createApp(App)

app.use(router)
app.use(createPinia())
app.use(Antd)
app.use(VueAxios, api)
app.config.globalProperties.$request = api

app.mount('#app')
